import { createAsyncThunk } from '@reduxjs/toolkit';
import type TwilioApi from 'api/TwilionApi';
import { DEBOUNCE_TIMEOUT } from 'thunks/thunks.config';
import debounce from 'utils/debounce';
import { logger } from 'utils/logger';

export const createVerifyCodeThunk = (api: TwilioApi) => {
  const debouncedApiCall = debounce(
    (data: { applicationId: string; submissionId: string; verificationCode: string }) =>
      api.verifyCode(data),
    DEBOUNCE_TIMEOUT,
  );

  return createAsyncThunk(
    'twilio/verifyCode',
    async (data: { applicationId: string; submissionId: string; verificationCode: string }) => {
      try {
        logger.info(`Twilio create verify code ${data.applicationId}`);

        return await debouncedApiCall(data);
      } catch (error) {
        logger.error(`Twilio verify code failed for application ${data.applicationId}`, error);

        throw error;
      }
    },
  );
};
